import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { UserBadgePageProps } from './components/UserBadgePageContent';

const UserBadgePageContent = lazy(
  () => import('./components/UserBadgePageContent'),
);

// this page severs as an intermediate page that load the user badge
// and either show the user badge detail page or does nothing if badge not exist,
// and the page is primarily intended to be opened by links.
export const UserBadgePage = wrapNavigatorScreen(
  (props: UserBadgePageProps) => {
    return <UserBadgePageContent {...props} />;
  },
  {
    presentation: 'transparentModal',
    headerShown: false,
    animationEnabled: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
  },
);
